import React, { useState, useEffect, useRef } from 'react';
import AuthService                    from 'services/auth.service';
import AuditLogService                from 'services/audit-log.service';
import AuditLogsFilter                from './AuditLogsFilter';
import { Table }                      from 'react-bootstrap';
import Spinner                        from 'react-bootstrap/Spinner';
import IconLog                        from 'assets/icons/auditLogDefaultIcon.svg';
import IconAppointment                from 'assets/icons/Appointment.svg';
import IconPen                        from 'assets/icons/Pen.svg';
import moment                         from 'moment';
import 'moment-timezone';

export function AuditLogs() {
  const sources = {
    Appointment: IconAppointment,
    PracticeLocation: IconAppointment,
    Asset: IconPen
  }
  const ruleTypes = {
    1: 'Only this week',
    2: 'Only this month',
    3: 'Every week'
  }
  const practiceLocation = AuthService.getPracticeLocation();
  const defaultMeta = {total_count: 0, total_pages: 0, current_page: 1};
  const isClosed = useRef(false);
  const [meta, setMeta] = useState(defaultMeta);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    getAuditLogs(1);
    return () => {
      isClosed.current = true;
    };
  }, [startDate, endDate]); // eslint-disable-line

  const getAuditLogs = (page) => {
    setPage(page);
    setLoading(true);
    const params = {
      page: page,
      location_id: practiceLocation?.id,
      sort_by: 'newest',
      start_date: startDate,
      end_date: endDate,
    }
    AuditLogService.auditLogs(params).then(
      (data) => {
        setLogs(data.audit_logs)
        setMeta(data.meta)
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    ).then(() => {
      setLoading(false);
    });
  }

  const getIcon = (n) => {
    let icon = IconLog;
    if(sources[n.source]){
      icon = sources[n.source];
    }
    return icon;
  }

  const getMessageDetails = (n) => {
    return <div className="message" dangerouslySetInnerHTML={{ __html: getMessage(n)}} />
  }

  const getTimeStampToTime = (timeStamp, format) => {
    var timeFormat = format || null;
    return timeStamp ? moment.unix(timeStamp).tz('Asia/Kuala_Lumpur').format(timeFormat) : null;
  };

  const getMessage = (n) => {
    let payload = n.payload;
    var arr = []

    if(payload?.rule_type){
      arr.push(payload.editer, payload.location_status);
      if(payload?.location_status === 'updated Availabilty'){ arr.push('into') }
      arr.push(`<b>${getTimeStampToTime(payload.start_time, 'HH:mm')} - ${getTimeStampToTime(payload.end_time, 'HH:mm')}</b>`);
      arr.push(`(<b>${payload?.appointment_length} min</b> per appointment) at <b>${payload.location}, ${ruleTypes[payload.rule_type]}</b> from <b>${getTimeStampToTime(payload.start_time, 'Do MMM YYYY')}</b>`)
    }else{
      arr.push(n.message);
      arr.push('<b>');
      arr.push(`${getTimeStampToTime(payload?.appointment_time || payload?.start_time,'Do MMM YYYY, HH:mm A')}`, payload?.phone_number, payload?.plain_message);
      if(payload?.end_time || payload?.appointment_endtime){ arr.push(`- ${getTimeStampToTime(payload?.end_time || payload?.appointment_endtime,'Do MMM YYYY, HH:mm A')}`); }
      arr.push('</b>');
    }

    return arr.filter(function(x){return x !== null && x !== undefined && x !== 'null'}).join(' ');
  }

  const Logs = () => {
    if (loading) return <tr className="loader"><td className="border-bottom-0"><Spinner animation="border" className="spinner"/></td></tr>;
    if (logs.length === 0) return <tr className="loader"><td className="border-bottom-0">No Audit Available</td></tr>;

    return logs.map((n,i) => {
      return (
        <tr key={`audit-row-${i}`} className='w-100'>
          <td className="icon position-relative"><img src={getIcon(n)} alt="audit-icon" className={n.source}/></td>
          <td className="details">
            <div className="datetime">{moment(n.created_at).format('DD MMM YYYY, HH:mm A')}</div>
            {getMessageDetails(n)}
          </td>
        </tr>
      );
    })
  }

  return (
    <div id="main-content-target" className="audit-logs-page">
      <h1 className="text-danger">Audit Logs</h1>
      <div>
        <AuditLogsFilter getAuditLogs={getAuditLogs} meta={meta} page={page} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate}/>
        <Table className="audit-logs-table">
          <tbody>
            <Logs />
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default AuditLogs;